module.exports = __webpack_public_path__ + "img/portrait-084.6367553d.jpg";